import Enum from 'cg-enum'

export const termsEnum = new Enum(['spring', 'summer', 'autumn', 'winter'], 1)
export const termsName = {
  spring: '春',
  summer: '暑',
  autumn: '秋',
  winter: '寒',
  year: '年'
}



// WEBPACK FOOTER //
// ./src/defines/terms.js